import React from 'react';
import moment from 'moment';
import { useRouter } from 'next/router';
import { Icon } from '../../subkit-ui';
import styles from './PostPreview.module.sass';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var PostPreview = function PostPreview(_ref) {
  var previewText = _ref.previewText,
      title = _ref.title,
      postImageSrc = _ref.postImageSrc,
      date = _ref.date,
      postLocation = _ref.postLocation,
      isPaid = _ref.isPaid;
  var router = useRouter();

  var navigateToPost = function navigateToPost() {
    router.push(postLocation);
  };

  return /*#__PURE__*/_jsxs("div", {
    className: styles.root,
    onClick: navigateToPost,
    "data-cy": "PostPreview",
    children: [postImageSrc ? /*#__PURE__*/_jsx("img", {
      src: postImageSrc,
      alt: postImageSrc,
      className: "object-cover w-full rounded-lg h-80 min-h-80 w-80 min-w-80"
    }) : /*#__PURE__*/_jsx("div", {
      className: "w-full bg-gray-200 flex items-center justify-center rounded-lg h-80 min-h-80 w-80 min-w-80",
      children: /*#__PURE__*/_jsx("svg", {
        width: "74",
        height: "72",
        viewBox: "0 0 74 72",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M41.0351 34.3934L63.8165 24.7569L72.8738 2.33195C73.4385 0.933906 72.0323 -0.449586 70.6436 0.137734L22.8589 20.3476C17.4668 22.6281 17.3107 30.2128 22.6045 32.7132L32.9641 37.6063L10.1827 47.2428L1.12536 69.6677C0.5607 71.0658 1.96687 72.4493 3.35555 71.862L51.1403 51.6521C56.5324 49.3716 56.6884 41.7869 51.3947 39.2865L41.0351 34.3934Z",
          fill: "#B5B5B5"
        })
      })
    }), /*#__PURE__*/_jsx("h2", {
      className: styles.title,
      "data-cy": "title",
      children: title
    }), /*#__PURE__*/_jsxs("div", {
      className: "flex",
      children: [isPaid && /*#__PURE__*/_jsx(Icon, {
        name: "lock",
        className: "mr-2"
      }), /*#__PURE__*/_jsx("div", {
        className: "block text-gray-900",
        "data-cy": "PostPreviewStartDate",
        children: moment(date).format('MMMM DD, YYYY')
      })]
    }), /*#__PURE__*/_jsx("p", {
      className: "font-sans font-normal text-neutral-400 leading-snug mt-3 line-clamp-3",
      children: previewText
    })]
  }, title);
};

export default PostPreview;